import React, { useState, ChangeEvent, useRef } from 'react';
import { Box, Button, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import './style.css';
import { LoadingModalProps } from '../../../models';
import { useNavigate } from 'react-router-dom';
import { PrivateRoutes, PublicRoutes } from '../../../routes';
import { useDispatch } from 'react-redux';
import { resetLoading, updateLoading } from '../../../redux/states/loading';
import { onboardingTarjetasApi } from '../../../api/onboardingTarjetas';
import { setError } from '../../../redux/states/error';

interface VerificacionProps {
    onLoadingModalPrivate: (value: LoadingModalProps) => void;
  }


const textReenvioStyle = { 
    backgroundColor:"#E4FFFA", 
    padding:"2px", 
    marginTop:5, 
    width:{
        xs:"20rem",
        md:"35vw"
    }, 
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.501)' }

interface IopenSnack{
    open:boolean;
    message:string;
}

type ISetOpenSnack = (datos: IopenSnack) => void;

const VerificarEmail: React.FC<{idtramite:string, email:string, onOpenSnack:ISetOpenSnack, onSetPopUp:(value:boolean) => void, onUpModal:(value:boolean)=>void }> = ({idtramite, email, onOpenSnack, onSetPopUp, onUpModal}) => {

  const number1Ref = useRef<HTMLInputElement>(null);
  const number2Ref = useRef<HTMLInputElement>(null);
  const number3Ref = useRef<HTMLInputElement>(null);
  const number4Ref = useRef<HTMLInputElement>(null);
  const number5Ref = useRef<HTMLInputElement>(null);
  const number6Ref = useRef<HTMLInputElement>(null);

  const [inputs, setInputs] = useState<string[]>(['', '', '', '','','']);

  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleChange = (index: number, value: string) => {
    const newInputs = [...inputs];
    let indexIngresado = index;
    let valueIngresado = value

    if(value.length > 6){
        valueIngresado = valueIngresado.substring(0,6);
    }


    if(valueIngresado.length > 1 && valueIngresado.length <= 6 && newInputs[indexIngresado] == ''){

        const valueSplit = valueIngresado.split("");
        let i = 0;

        for(i = 0; i < valueIngresado.length; i++){
            newInputs[i] = valueSplit[i];
        }

        setInputs(newInputs);
    }else if(newInputs[indexIngresado] == '')
        {
        newInputs[indexIngresado] = valueIngresado;
        setInputs(newInputs);
    }


    if (valueIngresado !== '' && indexIngresado < 5) {
      const nextInputRef = indexIngresado === 0 ? number2Ref : indexIngresado === 1 ? number3Ref : indexIngresado === 2? number4Ref: indexIngresado === 3? number5Ref:number6Ref;
      nextInputRef.current?.focus();
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>, name: string) => {
    const index = name === 'number1' ? 0 : name === 'number2' ? 1 : name === 'number3' ? 2 : name === 'number4' ? 3: name === 'number5' ? 4: 5;


    if (event.key === 'Backspace' && inputs[index] === '' && index > 0) {
      const prevInputRef = index === 1 ? number1Ref : index === 2 ? number2Ref : index === 3? number3Ref: index === 4? number4Ref : number5Ref;
      prevInputRef.current?.focus();
    }else if(event.key === 'Backspace' && inputs[index] !== ''){
        const newInputs = [...inputs];
        newInputs[index] = '';
        setInputs(newInputs);

    }
  };

  function continuar(){
    dispatch(updateLoading({ openLM: true, messageLM: 'Validando token...' }));

    const token = inputs.join('');
    console.log(`token: ${token} idtramite: ${idtramite}`)
    onboardingTarjetasApi
    .confirmarTokenEmail(token, idtramite)
    .then((response) => {
        console.log(`validarToken: ${JSON.stringify(response.data)}`);

        if (response.status === 200) {
            if (response.data.resultado) {
                navigate(`/${PrivateRoutes.PRIVATE}/${PrivateRoutes.FINALIZAR}`, {
                replace: true,
                });
                console.log("Su token fue validado correctamente...");
            } else {
                let mensajeError = "Hubo un error al verificar el token.";

                switch (response.data.errores.idError) {
                case 13:
                    mensajeError = "Ocurrió un error al validar el token, por favor volvé a intentar.";
                    break;
                case 8:
                    handleError(
                        response.data.errores.idError.toString(),
                        "Hubo un error en el proceso de solicitud, intentá nuevamente.",
                    );
                    break;
                case 16:
                    mensajeError = "El código se encuentra vencido. Hacé click en el botón \"AQUÍ\" para recibir un código nuevo.";
                    break;
                case 17:
                    mensajeError = "Se ha excedido la cantidad máxima de intentos. Hacé click en el botón \"AQUÍ\" para recibir un código nuevo.";
                    break;
                case 18:
                    mensajeError = "El código ingresado no coincide. Intentá nuevamente.";
                    break;
                case 19:
                    handleError(
                        response.data.errores.idError.toString(),
                        "Hubo un error en el proceso de solicitud, intentá nuevamente.",
                    );
                    break;
                }
                onOpenSnack({
                    open: true,
                    message: mensajeError,
                });
            }
        } else {
            onOpenSnack({
                open: true,
                message: "Hubo un error al verificar el token. Intentá nuevamente.",
            });
        }
    })
    .catch((error) => {
        if (error.response) {
            console.error("Error Status Code:", error.response.status);
            console.error("Error Status Message:", error.response.statusText);
            onOpenSnack({
                open: true,
                message: "Hubo un error al verificar el token. Intentá nuevamente.",
            });
        } else if (error.request) {
            console.error("No response from server:", error.request);
            onOpenSnack({
                open: true,
                message: "Hubo un error al verificar el token. Intentá nuevamente.",
            });
        } else {
            console.error("Error setting up the request:", error.message);
            onOpenSnack({
                open: true,
                message: "Hubo un error al verificar el token. Intentá nuevamente.",
            });
        }
    })
    .finally(() => {
        dispatch(resetLoading());
    });    
  }

  async function reEnviarToken() {
    try {
      dispatch(updateLoading({ openLM: true, messageLM: "Reenviando token..." }));
      const response = await onboardingTarjetasApi.reEnviarTokenEmail(
        idtramite,
        email
      );
      console.log("Token reenviado: ", response.data);
      if (!response.data.resultado) {
        onOpenSnack({
          open: true,
          message: "Hubo un error al reenviar el token.",
        });
      }
    } catch (error) {
      console.error("Error al reenviar el token:", error);
      onOpenSnack({
        open: true,
        message: "Hubo un error al intentar reenviar el token.",
      });
    } finally {
      dispatch(resetLoading());
    }
  }

  const handleError = (idError: string, message: string) => {
    console.error(message);

    dispatch(setError({
        idError: idError,
        mensaje: message,
    }));

    onOpenSnack({ open: true, message: message });

    setTimeout(() => {
        dispatch(resetLoading());
        navigate(`/${PublicRoutes.ERROR}`, { replace: true });
    }, 2000);
  };

  function regresar(){
    onUpModal(false);
    onSetPopUp(false);
  }

  return (
        <Grid container>
            <Grid item xs={12} textAlign={"center"} mt={4}>
                <Typography variant='h4'sx={{fontWeight:{xs:'700', md:'none'}, fontSize:{xs:'0.9rem', md:'2.3rem'}}}>
                ¡Necesitamos verificar tu correo electronico!
                </Typography>
                <Typography variant='h6'sx={{fontSize:{xs:'0.7rem', md:'1.3rem'}}}>
                    te hemos enviado un codigo a tu correo. Ingresalo aqui
                </Typography>
            </Grid>
            <Grid item xs={12} textAlign={"center"}>
                <div className="container">
                    <input
                        type="text"
                        name="number1"
                        value={inputs[0]}
                        onChange={(e) => handleChange(0, e.target.value)}
                        onKeyDown={(e) => handleKeyDown(e, 'number1')}
                        ref={number1Ref}
                        className="inputNumber"
                    />
                    <input
                        type="text"
                        name="number2"
                        value={inputs[1]}
                        onChange={(e) => handleChange(1, e.target.value)}
                        onKeyDown={(e) => handleKeyDown(e, 'number2')}
                        ref={number2Ref}
                        className="inputNumber"
                    />
                    <input
                        type="text"
                        name="number3"
                        value={inputs[2]}
                        onChange={(e) => handleChange(2, e.target.value)}
                        onKeyDown={(e) => handleKeyDown(e, 'number3')}
                        ref={number3Ref}
                        className="inputNumber" 
                        />
                    <input
                        type="text"
                        name="number4"
                        value={inputs[3]}
                        onChange={(e) => handleChange(3, e.target.value)}
                        onKeyDown={(e) => handleKeyDown(e, 'number4')}
                        ref={number4Ref}
                        className="inputNumber"
                        />
                    <input
                        type="text"
                        name="number5"
                        value={inputs[4]}
                        onChange={(e) => handleChange(4, e.target.value)}
                        onKeyDown={(e) => handleKeyDown(e, 'number5')}
                        ref={number5Ref}
                        className="inputNumber"
                        />
                    <input
                        type="text"
                        name="number6"
                        value={inputs[5]}
                        onChange={(e) => handleChange(5, e.target.value)}
                        onKeyDown={(e) => handleKeyDown(e, 'number6')}
                        ref={number6Ref}
                        className="inputNumber"
                        />
                </div>
            </Grid>
            <Grid
                item
                sx={{ marginBottom: { xs: 5, md: 10 } }}
                xs={12}
                justifyContent="center"
                alignItems="center"
                mb={10}
            >
                <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
                >
                    <Box sx={textReenvioStyle}>
                        <Typography
                        sx={{
                            fontSize: { xs: "0.6rem", md: "1.0rem" },
                            padding: { xs: 1, md: 2 },
                        }}
                        >
                        ¿No recibiste el código? Por favor, reintentá enviarlo presionando{" "}
                        <span
                            style={{ color: "#ff1744", fontWeight: "bold", cursor: "pointer" }}
                            onClick={reEnviarToken}
                        >
                            AQUÍ
                        </span>
                        </Typography>
                    </Box>
                </Box>
            </Grid>

            <Grid sx={{paddingLeft:{xs:4, md:20}, marginBottom:{xs:2, md:0}}} item xs={6}>
                <Button 
                    variant='contained' 
                    sx={{ 
                        backgroundColor: theme.palette.secondary.main,
                        '&:hover': {
                        backgroundColor: theme.palette.secondary.light,
                        },
                        '&:active': {
                        backgroundColor: theme.palette.secondary.main,
                        }
                        }}
                    onClick={regresar} 
                        >
            Regresar
            </Button>
            </Grid>

            <Grid  sx={{paddingLeft:{xs:4, md:15}}} item xs={6}>
                <Button variant='contained'  onClick={continuar}>Continuar</Button>
            </Grid>
        </Grid>
  );
}

export default VerificarEmail;
